import { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import './style.scss'
import CONFIG from '../../../config'
import { FormResponseStatus } from '../../models'
import { LayoutHome } from '../../containers'
import { Button, Divider, Title, Text, FormMessageSuccess, FormMessageInfo, AlertBrowser } from '../../components/UI'
import { Modal, ModalAuth, useModal } from '../../components/UI/Modal'
import { Login } from '../../components'
import { profileActions } from '../../store/actions'
import { useAuth } from '../../hooks'

const HomePage:FC = ()  => {
  const history = useHistory()
  const dispatch = useDispatch()
  const userCurrent = useAuth()
  const [option, setOption] = useState(0)
  const profileDeleteSw = useSelector((state: any) => state.profileDeleteSw)
  const modalProfileDelete = useModal()
  const modalPatient = useModal()

  useEffect(() => {
    profileDeleteValid()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const profileDeleteValid = () => {
    if(profileDeleteSw) {
      userCurrent.logout()
      modalProfileDelete.open()
    }
  }

  const redirect = (url: string) => history.push(url)

  const onSubmitStatus = (status: FormResponseStatus) => {
    if(status === 'SUCCESS') {
      redirect(CONFIG.ROUTES.DASHBOARD.HOME)
    } else if(status === 'ERROR') {
      setOption(1)
    } else if(status === 'ERROR_NOT_REGISTERED') {
      setOption(2)
    } else if(status === 'ERROR_YOUNGER') {
      modalPatient.open()
    } else if (status === 'ERROR_LOGGED_IN_OTHER_DEVICE') {
      setOption(3)
    }
  }

  const onModalProfileDeleteClose = () => {
    dispatch(profileActions.deleteProfileSw(false))
    modalProfileDelete.close()
  }

  return (
    <LayoutHome>
      {option === 0 &&
        <div className="mt-20">
          <Title component="h2" size="20" weight="bold" align="center">Iniciar sesión</Title>

          <Login className="mt-50" onSubmit={(status: any) => onSubmitStatus(status)} />

          <Divider className="mt-30 mb-20" />

          <Title component="h3" size="12" color="black" align="center">¿No tienes una cuenta?</Title>

          <Button component="link" to={`${CONFIG.ROUTES.AUTH.REGISTER.HOME}`} fullWidth className="mt-20" color="secondary_hover">CREAR NUEVA CUENTA</Button>
        </div>
      }

      {(option === 1 || option === 2) &&
        <div className="text-center mt-20">
          <Title component="h2" color="gray-300" size="20" weight="bold">Iniciar sesión</Title>
          <Text weight="semibold" className="mt-50">
            {option === 1 && 'Usuario o contraseña inválida'}
            {option === 2 && 'Lo sentimos, no existe una cuenta con esos datos'}
          </Text>

          <Button fullWidth className="mt-50 lg:mt-60" onClick={() => setOption(0)}>REINTENTAR</Button>

          {option === 1 &&
            <Button component="link" to={`${CONFIG.ROUTES.AUTH.FORGOTPASSWORD}`} fullWidth className="mt-30">RECUPERAR CONTRASEÑA</Button>
          }
          {option === 2 &&
            <Button component="link" to={`${CONFIG.ROUTES.AUTH.REGISTER.HOME}`} fullWidth className="mt-30" color="secondary_hover">CREAR NUEVA CUENTA</Button>
          }
        </div>
      }

      {option === 3 &&
          <div className="text-center mt-20">
            <Title component="h2" color="gray-300" size="20" weight="bold">Iniciar sesión</Title>
            <Text weight="semibold" className="mt-50">
              Por motivos de seguridad, debemos cerrar tu sesión, ya que has ingresado con tu cuenta en otro dispositivo. Para cualquier duda escríbenos a
              <a href="mailto:Portal@indisa.cl"> Portal@indisa.cl</a>
            </Text>

            <Button fullWidth className="mt-50 lg:mt-60" onClick={() => setOption(0)}>REINTENTAR</Button>
          </div>
      }


      <Modal show={modalProfileDelete.show} maxWidth="345px" onClose={onModalProfileDeleteClose}>
        <FormMessageSuccess
          title="El perfil ha sido eliminado"
          className="pt-80 pb-100 px-60"
        />
      </Modal>

      <ModalAuth />

      <Modal show={modalPatient.show} maxWidth="345px" onClose={() => modalPatient.close()}>
        <FormMessageInfo
          message="Ya eres mayor de edad, debes registrarte nuevamente"
          className="py-80 px-20"
          onClick={() => modalPatient.close()}
        />
      </Modal>
    </LayoutHome>
  )
}

export { HomePage }